import { render, staticRenderFns } from "./SubstancePlacement.vue?vue&type=template&id=38064feb&"
import script from "./SubstancePlacement.vue?vue&type=script&lang=js&"
export * from "./SubstancePlacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports